import { useContext, useEffect, useRef, useState, } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Layout,  Menu as DefaultMenu } from "antd";
import { AndroidFilled, HomeOutlined, ProjectOutlined, ReadOutlined} from '@ant-design/icons';
import { AppContext } from "../../utils/AppContext";
import { USER_ROLE } from "../../constants";

const defaultItems = [
    {
        key: '',
        icon: <HomeOutlined />,
        label: 'Home',
        children: null                        
    },
    {
        key: 'self',
        icon: <ReadOutlined />,
        label: 'Trainings',
        children: [
            {   
                key: 'precimar_ulm_600_e',
                icon: <AndroidFilled />,
                label: 'Precimar ULM 600-E',
            }
        ]
    },
]

const defaultStudentItems = [
    {
        key: '',
        icon: <HomeOutlined />,
        label: 'Home',
        children: null                        
    },
    {
        key: 'self',
        icon: <ReadOutlined />,
        label: 'Trainings',
        children: [
            {   
                key: 'precimar_ulm_600_e',
                icon: <AndroidFilled />,
                label: 'Precimar ULM 600-E',
            }
        ]
    }
]

const selectMenuDataByRoute = {
    "": {
        openKeys: [""],
        selectedKeys: [""]
    },
    login: {
        openKeys: [""],
        selectedKeys: [""]
    },
    team: {
        openKeys: ["team"],
        selectedKeys: ["team"]
    },
    precimar_ulm_600_e: {
        openKeys: ["self"],
        selectedKeys: ["precimar_ulm_600_e"]
    }
}

const Menu = () => {
    const { showMenu, userInfo } = useContext(AppContext);

    const navigate = useNavigate();

    const location = useLocation();
    const pathname = location.pathname.split("/")[1];
    const menuData = selectMenuDataByRoute[pathname]??{openKeys: pathname, selectedKeys: pathname };
   
    const [openKeys, setOpenKeys] = useState(menuData.openKeys);
    const [selectedKeys, setSelectedKeys] = useState(menuData.selectedKeys);

    const menu = useRef();

    const handleOnSelectMenu = (e) => {
        let url = e.key;
        if(url === "precimar_ulm_600_e") {
            let sessionId = localStorage.getItem("sessionId");
            url = url + "/" + sessionId;
        }
        navigate(`/${url}`)
        setSelectedKeys([`${e.key}`])
    }

    const handleOnOpenChange = (e) => {
        setOpenKeys([`${e[1]}`])
    }

    useEffect(() => {
        let data = selectMenuDataByRoute[location.pathname.split("/")[1]];
        if(data) {
            setOpenKeys(data.openKeys);
            setSelectedKeys(data.selectedKeys);
        }

    }, [location])
    
    return (
        <Layout.Sider trigger={null} collapsible collapsed={showMenu}>
            <DefaultMenu
                ref={menu}
                theme="dark"
                mode="inline"
                onSelect={(e) => handleOnSelectMenu(e) }
                onOpenChange={(e) => handleOnOpenChange(e)}
                items={userInfo.user_role !== USER_ROLE.STUDENT ? defaultItems: defaultStudentItems}
                openKeys={openKeys}
                selectedKeys={selectedKeys}
            />
        </Layout.Sider>
    );
}

export default Menu;